import { createSlice } from "@reduxjs/toolkit";

// Restore sessionToken from localStorage on app init
const savedToken = localStorage.getItem("kinde_tokens");

const initialState = {
  user: null,
  sessionToken: savedToken ? JSON.parse(savedToken).accessToken : null,
  idToken: savedToken ? JSON.parse(savedToken).idToken : null,
  isSuccess: false,
  isError: false,
  message: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
      state.sessionToken = null;
      state.idToken = null;
      localStorage.removeItem("kinde_tokens");
    },
    setSessionToken: (state, action) => {
      state.sessionToken = action.payload.accessToken;
      state.idToken = action.payload.idToken;
      // Persist token to localStorage
      if (action.payload) {
        localStorage.setItem(
          "kinde_tokens",
          JSON.stringify({
            accessToken: action.payload.accessToken,
            idToken: action.payload.idToken,
          })
        );
      } else {
        localStorage.removeItem("kinde_tokens");
      }
    },
  },
});

export const { setUser, clearUser, setSessionToken } = authSlice.actions;

export default authSlice.reducer;
